  <template>
  <div>
  <b-modal style="padding:15px" size="lg" id="EditContractorModal" ref="modal" title="Edit Contractor" ok-title="Submit" cancel-title="Close" 
      @hidden= "resetModal()" @show= "updateModel()" @ok= "handleOk" :ok-disabled = "this.$refs.EditContractorForm != undefined ? !this.$refs.EditContractorForm.checkValidity() : true">
        <form ref="EditContractorForm" @submit.stop.prevent= "handleSubmit">
          <div class="row">
            <div class="col-md-6">
              <!--NAME INPUT-->
               <b-form-group  label="Name" label-for="Name" autocomplete="off">
                <b-form-input id="Name" v-model= "Name" type = "text"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
               <b-form-group  label="Phone Number" label-for="PhoneNumber" autocomplete="off">
                <b-form-input id="PhoneNumber" v-model= "PhoneNumber" type = "text"  required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group  label="Address" label-for="Address" autocomplete="off">
                <b-form-input id="Address" v-model= "Address" type = "text" required></b-form-input>
              </b-form-group>
            </div>
            <div class="col-md-6">
              <b-form-group label="Status">
                <b-form-radio-group
                  v-model="IsActive"
                  :options="statusOptions"
                  name="radio-inline"
                ></b-form-radio-group>
              </b-form-group>
            </div>
          </div>
                  
        </form>
      </b-modal>
      <Toaster ref = "toaster"/>
    </div>
      </template>

      <script>
import axios from 'axios';
// import config from '../config.js';
import Toaster from '../../toaster'
export default {
    name: 'EditContractor',
    data(){
        return{
          moduleName:'Edit Contractor',
          Name:null,
          Id:null,
          PhoneNumber:null,
          Address:null, 
          IsActive:false,    
          statusOptions:[
            {text:'Active',value:true},
            {text:'InActive',value:false},

          ]
		}
  },
components:{
Toaster
},

props:{
  contractorToEdit:{
    type:Object,
    default:null
  }
},
methods:{

    AddContractor(){ 
     console.log(this.IsActive)
     axios.post('/Contractor/edit', 
      {"Id":this.Id,"Name":this.Name,"PhoneNumber":this.PhoneNumber, "Address":this.Address,"IsActive":this.IsActive,
      "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id
      
      })
      .then(res=>{
        console.log(res)
            if(res.data.status == 1)
            {
               
                this.$refs.toaster.showToast('Sucess','success','Contractor has been updated successfully')
                 this.$bvModal.hide('EditContractorModal')
                 this.$parent.getPage();      
            }
             else if(res.data.status == -1)
            {
                 this.$refs.toaster.showToast('Error','danger',res.data.msg)
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.EditContractorForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
        this.Address = null;
        this.PhoneNumber = null;
        this.Name = null; 
      },
      updateModel()
      {
        console.log(this.contractorToEdit)
        this.Id = this.contractorToEdit.id,
        this.IsActive = this.contractorToEdit.isActive,
        this.Address = this.contractorToEdit.address,
        this.PhoneNumber = this.contractorToEdit.phoneNumber,
        this.Name = this.contractorToEdit.name
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.AddContractor()
        
       
      },
 
  
  },
	

}
</script>
